<div *ngIf="inputControl.errors && submitted" class="input-error mt-n1">
  <div *ngIf="inputControl.errors.required">{{controlName}} {{'IS_REQUIRED'|translate}}</div>
  <div *ngIf="inputControl.errors.email">{{controlName}} {{'IS_EMAIL'|translate}}</div>
</div>
